import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import classNames from 'classnames';
import { AnimatePresence } from 'framer-motion';
import DataTabHeader from './DataTabHeader';
const getFirstTabKey = (children) => {
    const [firstItem] = children;
    return firstItem === null || firstItem === void 0 ? void 0 : firstItem.props.tabKey;
};
const DataTabs = (props) => {
    const { activeKey = '', bordered = true, className: wrapperClassName, commonTabContent, disableTransition = false, arrowClassName = 'bg-highlight-dark border-color-transparent', onSelectTab = () => { }, tabActiveClassName = 'bg-highlight-dark text-color-white', tabClassName = '', tabContentClassName = '', tabFirstChildClassName = '', tabHoverClassName = 'bg-highlight-decent text-color-darkest', tabLastChildClassName = '', tabsWrapperClassName = '', vertical = false, children } = props, remainingProps = __rest(props, ["activeKey", "bordered", "className", "commonTabContent", "disableTransition", "arrowClassName", "onSelectTab", "tabActiveClassName", "tabClassName", "tabContentClassName", "tabFirstChildClassName", "tabHoverClassName", "tabLastChildClassName", "tabsWrapperClassName", "vertical", "children"]);
    const [internalActiveKey, setInternalActiveKey] = useState(activeKey || getFirstTabKey(React.Children.toArray(children)));
    // Update internal activeKey when props change
    const [previousActiveKey, setPreviousActiveKey] = useState(activeKey);
    if (activeKey !== previousActiveKey) {
        activeKey && setInternalActiveKey(activeKey);
        setPreviousActiveKey(activeKey);
    }
    const handleSelectTab = (event) => {
        var _a;
        onSelectTab((_a = event.currentTarget) === null || _a === void 0 ? void 0 : _a.getAttribute('data-tabkey'));
    };
    const wrapperClassNames = classNames('DataTabsContainer', bordered && 'DataTab-bordered', wrapperClassName, vertical ? 'DataTabs-vertical' : 'DataTabs-horizontal');
    const enrichChildren = () => {
        if (disableTransition) {
            return React.Children.map(children, child => {
                if (!child) {
                    return null;
                }
                return React.cloneElement(child, {
                    active: child.props.tabKey === internalActiveKey,
                    disableTransition,
                });
            });
        }
        const enhancedChildren = React.Children.toArray(children)
            .filter(child => child.props.tabKey === internalActiveKey)
            .map(child => React.cloneElement(child, { active: true, disableTransition }));
        return (
        // @ts-ignore
        _jsx(AnimatePresence, Object.assign({ initial: false, exitBeforeEnter: true }, { children: enhancedChildren })));
    };
    return (_jsxs("div", Object.assign({}, remainingProps, { className: wrapperClassNames }, { children: [_jsx("div", Object.assign({ className: `DataTabsWrapper ${tabsWrapperClassName}` }, { children: _jsx("ul", Object.assign({ className: 'DataTabs', role: 'tabList' }, { children: React.Children.map(children, (child, index) => {
                        if (!child) {
                            return null;
                        }
                        const { tabKey, title, className } = child.props;
                        return (_jsx(DataTabHeader, { isActive: tabKey === internalActiveKey, tabKey: tabKey, title: title, onSelectTab: handleSelectTab, isFirstTab: index === 0, isLastTab: !!((children === null || children === void 0 ? void 0 : children.length) - 1), tabFirstChildClassName: tabFirstChildClassName, tabLastChildClassName: tabLastChildClassName, tabActiveClassName: tabActiveClassName, tabClassName: tabClassName, tabHoverClassName: tabHoverClassName, arrowClassName: arrowClassName, className: className }));
                    }) })) })), _jsx("div", Object.assign({ className: `tab-content ${tabContentClassName}`, role: 'tabpanel' }, { children: commonTabContent ? commonTabContent : enrichChildren() }))] })));
};
export default DataTabs;
